import { useState } from 'react';
import api from '../services/api';

const round2 = (n) => Math.round(((Number(n) || 0) + Number.EPSILON) * 100) / 100;

/**
 * Z listy zwalidowanych kuponow (kolejnosc wpisania) buduje wiersze
 * split_payments dla serwera: kazdy kupon schodzi ze swojego salda
 * kwota = min(saldo, reszta do zaplaty). Kupony, na ktore nic nie zostalo,
 * sa pomijane. To JEDNA sciezka serwera - ta sama co platnosc dzielona.
 *
 * @returns {{ rows: Array<{method:'kupon', amount:number, couponCode:string}>, pokryte:number, reszta:number }}
 */
export function zbudujSplitZKuponow(coupons, totalAmount) {
  const doZaplaty = round2(totalAmount);
  let reszta = doZaplaty;
  const rows = [];
  for (const c of coupons || []) {
    if (reszta <= 0) break;
    const saldo = round2(c.value);
    const kwota = round2(Math.min(saldo, reszta));
    if (kwota <= 0) continue;
    rows.push({
      method: 'kupon',
      amount: kwota,
      couponCode: String(c.code || '').trim().toUpperCase(),
    });
    reszta = round2(reszta - kwota);
  }
  return { rows, pokryte: round2(doZaplaty - reszta), reszta };
}

const useCouponPayment = () => {
  const [showCouponPaymentModal, setShowCouponPaymentModal] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [couponData, setCouponData] = useState(null);
  const [couponValidating, setCouponValidating] = useState(false);
  // K5: lista zwalidowanych kart, gdy jedna nie pokrywa naleznosci
  const [coupons, setCoupons] = useState([]);
  const [couponError, setCouponError] = useState('');

  const validateCouponCode = async (code) => {
    if (!code || code.length < 4) return null;

    setCouponValidating(true);
    try {
      const response = await api.get(`/coupons/validate/${code.toUpperCase()}`);
      const data = response.data;

      if (data.success && data.data && data.data.valid) {
        return data.data;
      } else {
        const errors = data.data?.errors || [];
        const errorMessage = errors.length > 0 ? errors.join(', ') : (data.message || 'Kupon nie jest wazny');
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('Blad walidacji kuponu:', error);
      throw error;
    } finally {
      setCouponValidating(false);
    }
  };

  const addCoupon = (validated) => {
    setCoupons(prev => [...prev, validated]);
    setCouponError('');
  };

  const removeCoupon = (code) => {
    setCoupons(prev => prev.filter(c => c.code !== code));
    setCouponError('');
  };

  const resetCouponPaymentModal = () => {
    setCouponCode('');
    setCouponData(null);
    setCoupons([]);
    setCouponError('');
    setShowCouponPaymentModal(false);
  };

  return {
    showCouponPaymentModal,
    setShowCouponPaymentModal,
    couponCode,
    setCouponCode,
    couponData,
    setCouponData,
    couponValidating,
    validateCouponCode,
    coupons,
    addCoupon,
    removeCoupon,
    couponError,
    setCouponError,
    resetCouponPaymentModal
  };
};

export default useCouponPayment;
